import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"
import { NotFound } from "@/components/shell/route-states"
import type { RouterContext } from "@/router"

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
})
